// @flow

export const FRIENDS_REQUESTS_INITIATING = 'FRIENDS_REQUESTS_INITIATING'
export const FRIENDS_REQUESTS_INITIATED = 'FRIENDS_REQUESTS_INITIATED'
export const FRIENDS_REQUESTS_PAGE = 'FRIENDS_REQUEST_LOAD'
export const FRIENDS_REQUESTS_HANDLE = 'FRIENDS_REQUESTS_HANDLE'
export const FRIENDS_REQUEST_LOADED = 'FRIENDS_REQUEST_LOADED'
